import { Client } from "@stomp/stompjs";
import axios from "axios";
import SockJS from "sockjs-client";

let stompClient = null;

export const connectNotifyWebSocket = (
  userId,
  onMessageReceived,
) => {
  const API_BASE_URL = "https://api.ipaisa.co.in/myapp";

  if (stompClient && stompClient.connected) {
    console.log("Already connected to WebSocket");
    return;
  }


  const socket = new SockJS(`${API_BASE_URL}/notify`);
  stompClient = new Client({
    webSocketFactory: () => socket,
    reconnectDelay: 2000,
    debug: (msg) => console.log(`🔍 STOMP Debug: ${msg}`), // Debugging logs

    onConnect: async () => {
      console.log("✅ WebSocket connected!");
      

      // ✅ Subscribe only if connected
      if (stompClient && stompClient.connected) {
        console.log("📡 Subscribing to messages...");
        stompClient.subscribe(`/notifications/${userId}`, (message) => {
          const check = JSON.parse(message.body);
          console.log(check);
          onMessageReceived(check);
        });

        // if (stompClient && stompClient.connected) {
        //   // ✅ Only fetch status if connected
        //   fetchLastKnownStatus(ticketId);
        // }

        // stompClient.subscribe(`/supportchat/${ticketId}/status`, (message) => {
        //   const status = JSON.parse(message.body);
        //   console.log("📢 Status update:", status);
        //   status.employeeConnected
        //     ? onEmployeeConnected()
        //     : onEmployeeDisconnected();
        // });
      } else {
        console.warn("⚠ STOMP is not connected. Skipping subscriptions.");
      }
    },

    onDisconnect: () => {
      console.warn("🔌 WebSocket disconnected.");
    },

    onStompError: (error) => console.error("🚨 STOMP error:", error),
  });

  stompClient.activate();
};

export const notifyRead = (userId) => {
  if (stompClient && stompClient.connected) {
    // Send via WebSocket
    stompClient.publish({
      destination: `/app/readBy/${userId}`, // FIXED MISSING '/app'
    });
  }
};

export const disconnectNotifyWebSocket = () => {
  if (stompClient && stompClient.connected) {
    console.log(`🔍 STOMP Disconnect: `);
    // Notify backend that the user is disconnected
    stompClient.publish({
      destination: `/app/userdisconnect/`,
    });
    stompClient.deactivate();
  }
};
